import { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useTranslation } from 'react-i18next';

import { toggleSupport, sendFeedback, toggleModalFeedbackThanks, clearFeedbackSentStatus } from '../../../redux/main/main.actions';
import { selectIsModalSupportEnabled, selectModalSupportData, selectFeedbackSentStatus } from '../../../redux/main/main.selectors';

import { showNotify } from '../../../redux/notify/notify.actions';

import Modal from '../Modal/Modal';
import './ModalFeedback.scss';


export const ModalFeedback = () => {
    const dispatch = useDispatch();
    const { t, i18n } = useTranslation();

    const isOpen = useSelector(selectIsModalSupportEnabled);
    const modalData = useSelector(selectModalSupportData);

    const inputRef = useRef(null);
    const [value, setValue] = useState('');
    const [contentType, setContentType] = useState('');
    const [page, setPage] = useState('');

    const feedbackSentStatus = useSelector(selectFeedbackSentStatus);
    const [sentCount, setSentCount] = useState(0);

    useEffect(() => {
        setPage(modalData?.page);

        if (!modalData?.type) return;

        setContentType(modalData?.type || 'feedback');
        return () => { };
    }, [modalData]);


    useEffect(() => {
        if (feedbackSentStatus === 'success') {
            dispatch(toggleSupport(null));
            dispatch(toggleModalFeedbackThanks(contentType, page));

            setTimeout(() => {
                setPage('');
                setValue('');
                setSentCount(0);
            }, 300);

        } else if (feedbackSentStatus === 'error') {
            if (inputRef.current && (window.innerWidth >= 1000)) {
                inputRef.current.focus();
            }
        }

        return () => {
            dispatch(clearFeedbackSentStatus());
        };
    }, [feedbackSentStatus]);

    const handleSave = () => {
        if (!value) {
            dispatch(showNotify({ message: 'please_enter_message' }));
            if (inputRef.current && (window.innerWidth >= 1000)) {
                inputRef.current.focus();
            }
            return;
        }

        if (sentCount > 4) return;

        const data = {
            message: value,
            t: modalData?.type,
            i: 'a',
            j: 'm',
        };

        setSentCount(sentCount + 1);
        dispatch(sendFeedback(data));
    };

    const handleCancel = () => {
        dispatch(toggleSupport(null));
        setTimeout(() => {
            setPage('');
            setValue('');
            setSentCount(0);
        }, 300);
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter' && (e.ctrlKey || e.metaKey) && !e.shiftKey && !e.altKey) {
            e.preventDefault();
            handleSave();
        }
    };

    const handleChange = (e) => {
        if (e.target.value?.length < 1200) {
            setValue(e.target.value);
        }
    }

    if (!contentType) return null;

    return (
        <Modal
            isOpen={isOpen}
            modalClass={`modal-feedback-main ${page}`}
            // modalClass={`modal-feedback-main ${modalData?.type === 'main' ? 'feedback-canvas' : ''} ${viewType}`}

            onCancel={handleCancel}
        >
            <div className="modal-content-header">{t(`m_feedback.${contentType}.name`)}</div>
            <div className="modal-content-body">
                <textarea
                    ref={inputRef}
                    // id="modal-feedback-main-text"
                    autoComplete="off"
                    maxLength={1000}
                    autoFocus={(window.innerWidth >= 1000)}
                    spellCheck="false"
                    placeholder={t(`m_feedback.${contentType}.desc`)}
                    value={value}
                    onChange={handleChange}
                    onKeyDown={handleKeyDown}
                    onFocus={(e) => {
                        requestAnimationFrame(() => {
                            setTimeout(() => {
                                e.target.scrollIntoView({
                                    behavior: 'auto',
                                    block: 'center',
                                });
                            }, 300);
                        });
                    }}
                />
                <button
                    disabled={sentCount > 4}
                    onClick={() => handleSave()}>{t('b.send')}</button>
            </div>
        </Modal>
    );
};

export default ModalFeedback;
